import { Search } from '@styled-icons/bootstrap/Search';
import { CompetitionListSchema } from '@/views/sports/components/CompetitionList/styles/CompetitionList.styles';

export const competitionListStyles: CompetitionListSchema = {
  skeleton: {
    startColor: 'beta.300',
    endColor: 'beta.400',
    minW: 'full',
    h: '20',
    borderRadius: 'md',
    flex: 1,
    mt: '8',
  },
  input: {
    name: 'x',
    sxWrapper: { mb: '0' },
    bg: 'blackAlpha.600',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.05)',
    borderRadius: 'md',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: '2xs',
    mb: '0',
    _hover: {
      borderRadius: 'md',
      '&&': {
        bg: 'blackAlpha.700',
      },
    },

    _focus: {
      boxShadow: 'xl',
      borderColor: 'alpha.500',
      color: 'alpha.500',
      textShadow: 'sm',
      '&&': {
        bg: 'blackAlpha.700',
      },
    },
    _placeholder: {
      color: 'whiteAlpha.500',
    },
  },
  inputRightIcon: {
    color: '#ECC94B',
    boxSize: '4',
    fontWeight: 'black',
    fontSize: 'md',
    as: Search,
  },
  accordion: {
    color: 'white',
    mb: '3',
    variant: 'unstyled',
    w: 'full',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    py: '1',
    // borderTop: '1px',
    // borderTopColor: 'blackAlpha.400',
    _first: {
      borderTop: 'none',
    },
  },
  accordionButton: {
    px: '0',
    pos: 'relative',
    _hover: { bg: 'transparent' },
  },
  hStack: {
    w: 'full',
    alignItems: 'center',
  },
  flex: { alignItems: 'center', gap: 2, flex: 1, textAlign: 'left' },
  accordionButtonIconSvg: {
    color: 'gamma.600',
    fontSize: 'md',
    fontWeight: 'black',
  },
  accordionButtonText: {
    color: 'brand.700',
    fontSize: ['sm', 'md'],
    fontWeight: 'medium',
    textTransform: 'capitalize',
  },
  marketTypesFlex: {
    mr: '2',
    gap: '2',
  },
  marketTypesText: {
    color: '#2D3748',
    w: ['50px', '100px'],
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'capitalize',
  },
  accordionButtonInnerIcon: {
    pos: 'absolute',
    right: '0',
    boxSize: '6',
    color: 'white',
  },
  accordionPanel: {
    p: '0',
    mb: '3',
  },
};
